import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Buefy from 'buefy'
import VueGtag from "vue-gtag";
import 'buefy/dist/buefy.css'

import '@/assets/style.scss'

Vue.use(Buefy)
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "251637606" }
});

document.title = "Growingtiktok.com - Go viral with your account"

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
